import { render, staticRenderFns } from "./ManagePaymentProvisions.vue?vue&type=template&id=7c77db02&scoped=true&"
import script from "./ManagePaymentProvisions.vue?vue&type=script&lang=js&"
export * from "./ManagePaymentProvisions.vue?vue&type=script&lang=js&"
import style0 from "./ManagePaymentProvisions.vue?vue&type=style&index=0&id=7c77db02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c77db02",
  null
  
)

export default component.exports